import classNames from 'classnames'
import React, { HTMLProps } from 'react'
import * as styles from '../styles/components/heading.module.scss'

export type HeadingProps = HTMLProps<HTMLHeadingElement>

const Heading = ({ className, as = 'h2', children, ...rest }: HeadingProps) => {
    const props = { className: classNames(styles.heading, className), ...rest }
    const H = as

    return (
        <H {...props}>
            {children}
        </H>
    )
}

export default Heading
